const DEFAULT_DISCOUNT_PERCENTAGES = {
    twoPack: "Most Popular",
    sixPack: "Best Price"
}

function initNewVariantSelectorChanges() {
  console.log("RUN")
  const productInfoWrapper = document.querySelector(".product__info-wrapper");
  productInfoWrapper?.classList?.add("PS-001-product-info-wrapper");

  const productInfo = productInfoWrapper?.querySelector(".product__info-container");
  productInfo?.classList?.add("PS-001-product-info");

  const variantSelectorsWrapper = productInfo.querySelector("variant-radios");

  if (!variantSelectorsWrapper || !productInfo) return;
  variantSelectorsWrapper.classList.add("PS-001-variant-selectors");

  const variantSelectors = productInfo.querySelectorAll("fieldset");

  variantSelectors.forEach((elm, idx) => {
    if(idx == 0 && variantSelectors.length > 1) {
        elm.classList.add("PS-001-select-size-cont");
        return
    }

    elm.classList.add("PS-001-select-qty-cont");

    const qtySelectorLabel = elm.querySelectorAll("label");
    qtySelectorLabel.forEach((label, idx) => {
      label.classList.add("PS-001-qty-selector-label");
      switch(idx) {
        case 0:
            label.innerHTML = createVariantHTML("Pack of 2", window.packDiscountSettings?.twoPack || DEFAULT_DISCOUNT_PERCENTAGES.twoPack, true)
            break
        case 1: 
            label.innerHTML = createVariantHTML("Pack of 1")
            break
        case 2: 
            label.innerHTML = createVariantHTML("Pack of 6", window.packDiscountSettings?.sixPack || DEFAULT_DISCOUNT_PERCENTAGES.sixPack)
            break
        default:
            break
      }
    });
  });
}

function createVariantHTML(title, save = "", isBestSeller = false) {
  let saveHTML = ``;
  if(save) {
    if(save == DEFAULT_DISCOUNT_PERCENTAGES.twoPack || save == DEFAULT_DISCOUNT_PERCENTAGES.sixPack) {
      saveHTML = `<p class="qty-save">${save}</p>`;
    } else {
      saveHTML = `<p class="qty-save">Save ${save}</p>`;
    }

  }
  return `
        <p class="qty-title">${title}</p>
        ${save ? saveHTML : ""}
        ${isBestSeller ? '<p class="qty-best-seller">BESTSELLER </p>' : ""}
    `;
}

initNewVariantSelectorChanges();